<template>
  <div class="space-between pd-400  bg-menu">
    <div class="color-f header-menu">
      <div class="fs-rem-18 bold mg-b-320" @click="jumpTo(overObj.route)">{{ overObj.name ? $t(overObj.name) : '' }}
      </div>
      <div class="flex-row">
        <div v-for="items in list" :key="items.name" class="mg-t-32  mg-r-500">
          <ul class="infinite-list dlist" style="overflow:auto">
            <li v-for="item in items" :key="item.name" class="infinite-list-item fs-rem-16 mg-b-240"
              @click="navClick(item)">
              {{ $t(item.name) }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="Boolean(overObj.imgUrl)" class="">
      <div class="w-rem-24">
        <img class="image w-rem-24 h-rem-17" :src="require(`@/assets/img2/${overObj.imgUrl}.png`)" alt="" />
        <div class="text-center color-f fs-rem-16 fw-400 mg-t-260">
          {{ overObj.imgDesc ? $t(overObj.imgDesc) : '' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 概览/概况 组件
export default {
  name: "Overview",
  inject: ['hideDropdrow'],
  props: {
    type: {
      type: String,
      default: 'produce'
    }
  },
  data() {
    return {
      titles: {
        produce: this.$t('header.menu0'),
        mark: this.$t('header.menu4'),
        salesSupport: this.$t('header.menu5'),
        about: this.$t('header.menu3'),
      },
      overObj: {},
      list: []
    }
  },
  mounted() {
    this.initOverView()
  },
  methods: {
    initOverView() {
      let overObj = {}
      let list = []
      if (this.type === 'produce') {
        overObj = {
          name: 'route.rou1',
          route: 'Produce',
          imgUrl: 'cpzx-rP_JuD7r',
          imgDesc: "header.spe6",
        }
        list = [
          [
            {
              name: 'EMMC.name',
              route: 'ProduceType',
              params: {
                itemType: 'embedding'
              }
            },
            {
              name: 'productCenter.embedding.emmc.name',
              fixedName: 'EMMC',
              route: 'ProduceInfo',
              params: {
                item: 'emmc'
              }
            },
            {
              name: 'productCenter.embedding.ufs.name',
              fixedName: 'UFS',
              route: 'ProduceInfo',
              params: {
                item: 'ufs'
              }
            },
            {
              name: 'productCenter.embedding.sip-ic.name',
              route: 'ProduceInfo',
              params: {
                item: 'sip-ic'
              }
            }
          ],
          [
            {
              name: 'M2.name',
              route: 'ProduceType',
              params: {
                itemType: 'rdimm'
              }
            },
            {
              name: 'header.spe0',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-25'
              }
            },
            {
              name: 'M2.zl',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-m2'
              }
            },
            {
              name: 'Special Conn SSD',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-sc'
              }
            },
            {
              name: 'header.spe1',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-ent'
              }
            },
            {
              name: 'header.spe2',
              route: 'ProduceInfo',
              params: {
                item: 'ssd-server'
              }
            },
          ],
          [
            {
              name: 'FB.name',
              route: 'ProduceType',
              params: {
                itemType: 'sd'
              }
            },
            {
              name: 'FB.zl',
              route: 'ProduceInfo',
              params: {
                item: 'dsd'
              }
            },
            {
              name: 'header.spe3',
              route: 'ProduceInfo',
              params: {
                item: 'csd'
              }
            },
            {
              name: 'header.spe4',
              route: 'ProduceInfo',
              params: {
                item: 'csc-rack'
              }
            },
            {
              name: 'header.spe5',
              route: 'ProduceInfo',
              params: {
                item: 'ida'
              }
            },
          ]
        ]
      } else if (this.type === 'mark') {
        overObj = {
          name: 'header.menu4',
          route: 'Mark',
          imgUrl: 'scyhy-D8o1Ve7V',
          imgDesc: "header.spe7",
        }
        list = [
          [
            {
              name: 'Solution.so0',
              route: 'IndustryPage',
              params: {
                item: 'dataCenter'
              }
            },
            {
              name: 'Solution.so2',
              route: 'IndustryPage',
              params: {
                item: 'PC'
              }
            },
            {
              name: 'Solution.so4',
              route: 'IndustryPage',
              params: {
                item: 'CAR'
              }
            },
            {
              name: 'Solution.so6',
              route: 'IndustryPage',
              params: {
                item: 'MobilePhone'
              }
            },
            {
              name: 'Solution.so8',
              route: 'IndustryPage',
              params: {
                item: 'AI'
              }
            }
          ],
          [
            {
              name: 'Solution.so10',
              route: 'IndustryPage',
              params: {
                item: 'Smart'
              }
            },
            {
              name: 'Solution.so12',
              route: 'IndustryPage',
              params: {
                item: 'Network'
              }
            },
            {
              name: 'Solution.so14',
              route: 'IndustryPage',
              params: {
                item: 'Industrial'
              }
            }
          ]
        ]
      } else if (this.type === 'salesSupport') {
        overObj = {
          name: 'header.menu5',
          route: 'SalesSupport',
          imgUrl: 'xsyzc-CLpAfVhZ',
          imgDesc: "header.spe8",
        }
        list = []
      } else if (this.type === 'about') {
        overObj = {
          name: 'message.ab',
          route: 'about',
          imgUrl: 'gywm-KwURyTex',
          imgDesc: "header.spe9",
        }
        list = [
          [
            {
              name: 'header.spe10',
              route: 'AboutView'
            },
            {
              name: 'header.spe11',
              route: 'MyCaption'
            },
            {
              name: 'header.spe12',
              route: 'ContUs'
            },
            {
              name: 'header.spe13',
              route: 'NewsView'
            }
          ]
        ]
      }
      else {

      }

      this.overObj = overObj
      this.list = list

    },
    jumpTo(route) {
      this.$router.push({
        name: route,
        // query: {
        //   itemType: "em"
        // }
      })
      this.hideDropdrow()
    },
    navClick(item) {
      this.$router.push({
        name: item.route,
        params: item.params
      })
      this.hideDropdrow()
    }
  }

}
</script>
<style lang="scss" scoped>
.header-menu {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.bg-menu {
  background: #fff3;
}
</style>


// WEBPACK FOOTER //
// src/components/Overview.vue